"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTippy = require("react-tippy");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _tooltip_styles = _interopRequireDefault(require("./tooltip_styles"));

require("react-tippy/dist/tippy.css");

var _tooltip_definition = _interopRequireDefault(require("./tooltip_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : TOOLTIP ~~~~~~~~~~ ========== */


var ToolTip =
/*#__PURE__*/
function (_Component) {
  _inherits(ToolTip, _Component);

  function ToolTip(props) {
    var _this;

    _classCallCheck(this, ToolTip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolTip).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleDelay", function () {
      _this.setState({
        open: false
      });

      setTimeout(function () {
        _this.setState({
          open: true
        });
      }, _this.props.delay);
    });

    _this.state = {
      open: _this.props.delay ? _this.handleDelay() : _this.props.open
    };
    return _this;
  }

  _createClass(ToolTip, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("span", {
        className: "tooltip"
      }, _react.default.createElement(_reactTippy.Tooltip, {
        html: this.props.content,
        position: this.props.position,
        trigger: this.props.trigger,
        open: this.state.open,
        distance: 15,
        followCursor: false,
        arrow: true,
        arrowSize: 'big',
        size: 'regular',
        multiple: true,
        sticky: true,
        stickyDuration: 100,
        interactive: true,
        animation: 'perspective',
        zIndex: this.props.zIndex,
        duration: 100
      }, this.props.children));
    }
  }]);

  return ToolTip;
}(_react.Component);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(ToolTip, _tooltip_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_tooltip_styles.default)(ToolTip);

exports.default = _default;